import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource } from 'kea-resource';

const controller = rpcController("FirmaRemota");


export const FirmaRemota = cacheResource({
    /**Crea o actualiza una firma remota */
    Update: async (id: string, firma: models.FirmaUsuario): Promise<void> => await controller("Update", { id }, firma),

    /**
     * Crea una entrada para recibir firmas    
     * @param mensaje 
     */
    Add: async (mensaje: string): Promise<string> => await controller("Add", { mensaje }),

    /**
     * Obtiene una firma usuario remota
     * @param id 
     */
    Get: async (id: string): Promise<models.FirmaUsuarioRemota> => await controller("Get", { id }),

    /**Borra una firma remota */
    Delete: async (id: string): Promise<void> => await controller("Delete", { id }),
});


// WEBPACK FOOTER //
// ./app/resources/items/firmaremota.tsx